const createSearchFilter = (searchTerm: string) => {
    return searchTerm ? `Domain;contains;"${searchTerm.trim()}"` : "";
};

const createCategoryFilter = (category: string) => {
    return category ? `Category;category;"${category}"` : "";
};

const createSourceTypeFilter = (sourceType: string) => {
    return sourceType ? `sourceType;==;"${sourceType}"` : "";
};
export const buildFiltersForTable = ({
    search,
    category,
    sourceType,
}: {
    search?: string;
    category?: string;
    sourceType?: string;
}) => {
    const filters = [createSourceTypeFilter(sourceType), createSearchFilter(search), createCategoryFilter(category)];
    const filtersString = filters.filter((tableFilter) => tableFilter && tableFilter.length > 0).join(",");
    return { filter: filtersString };
};
